<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M12.5 18V11.3333C12.5 11.1123 12.4122 10.9004 12.2559 10.7441C12.0996 10.5878 11.8877 10.5 11.6667 10.5H8.33333C8.11232 10.5 7.90036 10.5878 7.74408 10.7441C7.5878 10.9004 7.5 11.1123 7.5 11.3333V18"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 8.82966C2.49994 8.58722 2.55278 8.34768 2.65482 8.12776C2.75687 7.90784 2.90566 7.71283 3.09083 7.55633L8.92417 2.55633C9.22499 2.30209 9.60613 2.1626 10 2.1626C10.3939 2.1626 10.775 2.30209 11.0758 2.55633L16.9092 7.55633C17.0943 7.71283 17.2431 7.90784 17.3452 8.12776C17.4472 8.34768 17.5001 8.58722 17.5 8.82966V16.3297C17.5 16.7717 17.3244 17.1956 17.0118 17.5082C16.6993 17.8207 16.2754 17.9963 15.8333 17.9963H4.16667C3.72464 17.9963 3.30072 17.8207 2.98816 17.5082C2.67559 17.1956 2.5 16.7717 2.5 16.3297V8.82966Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconHome',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
